import { Alert, AlertIcon, Box, Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { AdaptedSelect, InputControl, Optional } from "../components/Form";
import {
    Gender,
    LanguageCode,
    useInsurancePoliciesQuery,
    useLanguagesQuery
} from "../graphql";

export interface IClientSignupUsingSigalInsurancePolicyFormValues {
  languageCode: LanguageCode;
  email: string;
  name: string;
  lastname: string;
  birthday: Date;
  phoneNumber: string;
  sex: Gender;
  insurancePoliceId: string;
  insurancePolicyCode: string;
}

interface IClientSignupUsingSigalInsurancePolicyForm {
  onSubmit: (values: IClientSignupUsingSigalInsurancePolicyFormValues) => void;
  initialValues?: Optional<IClientSignupUsingSigalInsurancePolicyFormValues>;
}

export const ClientSignupUsingSigalInsurancePolicyForm: React.FC<IClientSignupUsingSigalInsurancePolicyForm> = ({
    onSubmit,
    initialValues
}) => {
    const { data, loading } = useLanguagesQuery();

    const {
        data: insurancePolicyData,
        loading: insurancePoliciesLoading
    } = useInsurancePoliciesQuery();

    const validate = (values) => {
        const errors: { [key: string]: string } = {};

        if (!values.insurancePoliceId) {
            errors.insurancePoliceId = "Fushë e detyruar";
        }
        if (!values.insurancePolicyCode) {
            errors.insurancePolicyCode = "Fushë e detyruar";
        }

        if (!values.languageCode) {
            errors.languageCode = "Fushë e detyruar";
        }
        if (!values.email) {
            errors.email = "Fushë e detyruar";
        }

        if (!values.name) {
            errors.name = "Fushë e detyruar";
        }
        if (!values.lastname) {
            errors.lastname = "Fushë e detyruar";
        }
        if (!values.birthday) {
            errors.birthday = "Fushë e detyruar";
        }
        if (!values.phoneNumber) {
            errors.phoneNumber = "Fushë e detyruar";
        }
        if (!values.sex) {
            errors.sex = "Fushë e detyruar";
        }

        return errors;
    };

    return (
        <Form
            onSubmit={ onSubmit }
            validate={ validate }
            initialValues={ initialValues }
            render={ ({
                handleSubmit,
                form,
                errors,
                submitting,
                pristine,
                values
            }) => (
                <Box as="form" onSubmit={ handleSubmit }>
                    <InputControl type="text" name="name" label="Emri" />

                    <InputControl type="text" name="lastname" label="Mbiemri" />

                    <Field name="sex" component={ AdaptedSelect } label="Gjinia">
                        <option value="MALE">Mashkull</option>
                        <option value="FEMALE">Femër</option>
                    </Field>
                    <InputControl type="date" name="birthday" label="Datëlindja" />

                    <InputControl
                        type="text"
                        name="phoneNumber"
                        label="Numri i celularit"
                    />

                    <InputControl type="email" name="email" label="Email" />

                    <Field
                        name="insurancePoliceId"
                        component={ AdaptedSelect }
                        label="Polica"
                        disabled={ loading }
                    >
                        { insurancePolicyData?.insurancePolicies?.map((language) => (
                            <option value={ language.id }>{ language.name }</option>
                        )) }
                    </Field>

                    <InputControl
                        type="text"
                        name="insurancePolicyCode"
                        label="Numri serial/kartës i policës"
                    />

                    <Field
                        name="languageCode"
                        component={ AdaptedSelect }
                        label="Gjuha"
                        disabled={ loading }
                    >
                        { data?.languages?.map((language) => (
                            <option value={ language.code }>{ language.name }</option>
                        )) }
                    </Field>

                    <Alert status="info" marginBottom={ 4 }>
                        <AlertIcon />
                        Sigurohu që kodi dhe lloji i policës së sigurimit të jenë të sakta.
                    </Alert>

                    <ButtonGroup spacing={ 4 }>
                        <Button
                            isLoading={ submitting }
                            loadingText="Duke dërguar"
                            variantColor="teal"
                            type="submit"
                        >
                            Regjistro
                        </Button>
                        <Button
                            variantColor="teal"
                            variant="outline"
                            onClick={ form.reset }
                            isDisabled={ submitting || pristine }
                        >
                            Pastro
                        </Button>
                    </ButtonGroup>
                </Box>
            ) }
        />
    );
};
